import {fetch} from '../index';
import {QueryMethod} from '../utils';
import {
  GlobalSettingsDto,
  GlobalSettingsDtoResponse,
  WorkplaceSettingsDto,
} from '../../views/account-settings/requestObjects/intex';
import {TenantSettingsDto, TenantSettingsExtendedDto, UpdateTenantRequest,} from './dto';

export async function getTenantSettings() {
  return await fetch<TenantSettingsExtendedDto>(
      '/v1/tenants/settings',
      QueryMethod.GET,
  );
}

export async function updateGlobalTenantSettings(data: GlobalSettingsDto) {
  return await fetch<GlobalSettingsDto>(
      '/v1/tenants/global-settings',
      QueryMethod.PUT,
      data,
  );
}

export async function getGlobalSettings(): Promise<GlobalSettingsDtoResponse> {
  return await fetch<GlobalSettingsDtoResponse>(
      '/v1/tenants/global-settings',
      QueryMethod.GET,
  );
}

export async function getWorkplaceSettings() {
  return await fetch<WorkplaceSettingsDto>(
      '/v1/tenants/workplace-settings',
      QueryMethod.GET,
  );
}

export async function updateWorkplaceSettings(data: WorkplaceSettingsDto) {
  return await fetch<WorkplaceSettingsDto>(
      '/v1/tenants/workplace-settings',
      QueryMethod.PUT,
      data,
  );
}
export async function updateTenant(body: UpdateTenantRequest): Promise<TenantSettingsDto> {
  return await fetch(`/gogeta-api/v1/tenant`, QueryMethod.PUT, body);
}
